<template>
    <teleport to="body">
        <transition
            enter-active-class="animate__animated animate__fadeIn"
            leave-active-class="animate__animated animate__fadeOut"
            mode="out-in"
        >
            <div class="popup-backdoor" v-if="isVisible" @click="$emit('close')"></div>
        </transition>
        <transition
            enter-active-class="animate__animated animate__zoomIn animate__faster"
            leave-active-class="animate__animated animate__zoomOut animate__faster"
            mode="out-in"
        >
            <div v-if="isVisible" class="popup text-center">
                <div class="py-4">
                    <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex">
                        <div class="swal2-icon-content">!</div>
                    </div>
                    <p v-if="general">Are you sure you want to log off ?</p>
                    <p v-else>Some of the changes you made might be lost. Are you sure you want to log off?</p>
                </div>
                <div class="d-flex justify-content-between">
                    <button type="button" class="btn btn-main" @click="$emit('close')">Cancel</button>
                    <button type="button" class="btn btn-main" @click="logout()">Okay</button>
                </div>
            </div>
        </transition>
    </teleport>
</template>

<script>
import { mapStores } from "pinia"
import { useAuthStore } from "../../store/auth"
import Swal from "sweetalert2"

export default {
    name: "LogoutPopup",
    props: {
        isVisible: {
            type: Boolean,
            required: true,
        },
        general: {
            type: Boolean,
            required: true,
            default: true,
        },
    },
    emits: ["close", "next"],
    computed: {
        ...mapStores(useAuthStore),
    },
    methods: {
        logout() {
            this.authStore.logout()
            this.$emit("close")
        },
    },
}
</script>

<style scoped>
.popup-backdoor {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1100;
    transition: all 0.5s ease-in-out 0s;
}

.popup {
    position: fixed;
    top: 20px;
    left: calc(50% - 260px);
    width: 400px;
    z-index: 1100;
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #1f1f1f;
}

button:where(.swal2-styled) {
    margin: 0.3125em;
    padding: 0.625em 1.1em;
    transition: box-shadow 0.1s;
    box-shadow: 0 0 0 3px transparent;
    font-weight: 500;
}
button:where(.swal2-styled):not([disabled]) {
    cursor: pointer;
}
button:where(.swal2-styled).swal2-confirm {
    border: 0;
    border-radius: 0.25em;
    background: initial;
    background-color: #7066e0;
    color: #fff;
    font-size: 1em;
}
button:where(.swal2-styled).swal2-confirm:focus {
    box-shadow: 0 0 0 3px rgba(112, 102, 224, 0.5);
}
</style>
